<oes-modal-dialog
  [title]="title"
  [size]="'x-large'"
  [allowSubmit]="false"
  (close)="onClose()">
  <div class="files-preview-modal">
    <div *ngIf="isLoading" class="files-preview-loading">
      <div class="loading-ring loading-ring-small"><div></div><div></div><div></div><div></div></div>
      <p>{{ 'files.preview.loading' | translate }}</p>
    </div>

    <p *ngIf="errorMessage && !isLoading" class="files-preview-error">
      {{ errorMessage }}
    </p>

    <iframe
      *ngIf="previewKind === 'pdf' && previewUrl"
      class="files-preview-frame"
      [src]="previewUrl"
      title="File preview">
    </iframe>

    <img
      *ngIf="previewKind === 'image' && previewUrl"
      class="files-preview-image"
      [src]="previewUrl"
      [alt]="fileName">

    <pre *ngIf="previewKind === 'text' && textContent" class="files-preview-text">{{ textContent }}</pre>
  </div>
</oes-modal-dialog>
